import "./AdManagerBanners.scss";
import AdManagerBannersFilter from "@/components/AdManager/AdManagerBannersFilter/AdManagerBannersFilter.vue";
import AdManagerBannerEditDialog from "@/components/AdManager/AdManagerBannersEditDialog/AdManagerBannersEditDialog.vue";
import { getTokenHeader, getThumbnailUrl } from "@/helpers/commonHelper";
import axios from "axios";
import {
  getAdZoneItemText,
  getPrincipalsWithAdZoneInAppdinxLogin
} from "@/helpers/adManagerHelper";
import { updateAllNewsInApp } from "@/helpers/newsHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import ImagePreviewButton from "@/components/Common/ImagePreviewButton/ImagePreviewButton.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerBanners",
  components: {
    ImagePreviewButton,
    AdManagerBannersFilter,
    AdManagerBannerEditDialog
  },
  data: () => ({
    headers: [
      {
        text: "Vorschaubild",
        align: "start",
        value: "image",
        sortable: false
      },
      { text: "Name", value: "name" },
      { text: "Zeitraum", value: "period", sortable: false },
      { text: "Werbezonengruppe(n)", value: "groups", sortable: false },
      { text: "Werbezone(n)", value: "zones", sortable: false },
      { text: "Link", value: "href" },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    showPreviewImage:
      localStorage.getItem("showPreviewImage") === "true" || false,
    banners: [],
    zones: [],
    groups: [],
    total: 0,
    options: {},
    loading: true,
    loadingOverlay: false,
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    page: 1,
    itemsPerPage: 10,
    pageCount: 0,
    search: "",
    editDialog: false,
    editedItem: null,
    filter: {
      start_date: "",
      end_date: "",
      zones: [],
      groups: [],
      active: -1
    }
  }),
  async mounted() {
    await this.$store.dispatch("getPrincipals");
    await this.loadBanners();
    await this.loadZones();
    await this.loadGroups();
  },
  computed: {
    cHeaders() {
      if (!this.showPreviewImage) {
        return this.headers.filter(i => i.value !== "image");
      }
      return this.headers;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal?.id;
    },
    appAdZones() {
      return this.zones.filter(zone => zone.target === "app");
    }
  },
  methods: {
    getThumbnailUrl,
    getAdZoneItemText,
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    getZoneNameById(id) {
      const zone = this.zones.find(zone => zone._id === id);
      if (!zone) {
        return "---";
      }
      return this.getAdZoneItemText(zone);
    },
    getGroupNameById(id) {
      const group = this.groups.find(group => group._id === id);
      return group?.name ?? "---";
    },
    async createSuccess(successMessage) {
      await this.$store.dispatch("createSuccess", successMessage);
    },
    async createError(error) {
      await this.$store.dispatch("createError", error);
    },
    formatDate(d) {
      return new Date(d).toLocaleDateString("de-DE");
    },
    setShowPreviewImage() {
      this.showPreviewImage = !this.showPreviewImage;
      localStorage.setItem("showPreviewImage", this.showPreviewImage);
    },
    previewImageStyle(item) {
      const url = item.picture?.desktop?.url ?? item.picture?.mobile?.url;

      const isGif = url?.split(".")?.pop() === "gif";
      if (isGif) {
        return {
          backgroundImage: `url(${url})`,
          backgroundSize: "contain"
        };
      }
      const thumbnailUrl = this.getThumbnailUrl(url, "admanager", 70, "-");
      return {
        backgroundImage: `url(${thumbnailUrl})`
      };
    },
    getSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      return {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy?.[0] || "start_date",
        direction: sortDesc?.[0] ? "desc" : "asc",
        ...this.filter
      };
    },
    async loadBanners() {
      this.loading = true;
      const headers = getTokenHeader();
      try {
        const res = await axios.get(
          env.ad_manager_api_client_url + "ad/banners",
          {
            headers,
            params: this.getSearchParams()
          }
        );
        this.banners = res.data || [];
        const count = parseInt(res?.headers?.["x-count"]);
        this.total = isNaN(count) ? this.banners.length : count;
      } catch (e) {
        await this.createError("Fehler beim Laden der Banner");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async loadZones() {
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal,
          sort: "name",
          direction: "asc",
          limit: 9999
        };
        const r = await axios.get(env.ad_manager_api_client_url + "ad/zones", {
          headers,
          params
        });
        this.zones = r.data || [];
      } catch (e) {
        console.error(e);
      }
    },
    async loadGroups() {
      const headers = getTokenHeader();
      this.loading = true;
      try {
        const params = {
          principal_id: this.currentPrincipal,
          sort: "name",
          direction: "asc",
          limit: 9999
        };
        const r = await axios.get(env.ad_manager_api_client_url + "ad/groups", {
          headers,
          params
        });
        this.groups = r.data || [];
      } finally {
        this.loading = false;
      }
    },
    createItem() {
      this.editedItem = {
        _id: "",
        active: true,
        principal_id: this.currentPrincipal,
        name: "",
        href: "",
        picture: {
          desktop: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          },
          mobile: {
            title: "",
            url: "",
            originalFilename: "",
            width: null,
            height: null
          }
        },
        start_date: new Date().toISOString(),
        end_date: new Date(Date.now() + 7 * 86400000).toISOString(),
        zones: [],
        groups: [],
        is_link: true
      };
      this.editDialog = true;
    },
    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      // For existing data - remove at some point
      if (this.editedItem.picture.url) {
        this.editedItem.picture = {
          desktop: {
            ...this.editedItem.picture
          },
          mobile: {
            title: "",
            url: "",
            originalFilename: ""
          }
        };
      }
      this.editDialog = true;
    },
    async deleteItem(item) {
      const ok = await this.$confirm?.(
        `Banner <b>${item.name}</b> wirklich löschen?`,
        confirmWarningConfig
      );
      if (!ok) return;
      const headers = getTokenHeader();
      try {
        await axios.delete(
          env.ad_manager_api_client_url + "ad/banners/" + item._id,
          {
            headers,
            params: { principal_id: this.currentPrincipal }
          }
        );

        const itemGroupZones = this.groups
          .filter(group => item.groups.includes(group._id))
          .map(group => group.zones)
          .flat();
        const zoneIds = [...itemGroupZones, ...item.zones].map(
          zone => zone._id ?? zone
        );
        if (
          item.active &&
          this.appAdZones.some(zone => zoneIds.includes(zone._id))
        ) {
          new Set(
            this.appAdZones
              .map(zone => getPrincipalsWithAdZoneInAppdinxLogin(zone._id))
              .filter(arr => Array.isArray(arr) && arr.length > 0)
              .flat()
              .map(principal => principal.id)
          ).forEach(principalId => {
            updateAllNewsInApp(principalId, headers);
          });
        }
        await this.createSuccess("Banner gelöscht");
        await this.loadBanners();
      } catch (e) {
        await this.createError("Löschen fehlgeschlagen");
        console.error(e);
      }
    },
    async afterSave() {
      await this.loadBanners();
      await this.createSuccess("Erfolgreich gespeichert");
    },
    close() {
      this.editDialog = false;
      this.$nextTick(() => (this.editedItem = null));
    }
  },
  watch: {
    async options() {
      await this.loadBanners();
    },
    async search(val) {
      if (!val || val?.length >= 3) {
        await this.loadBanners();
      }
    },
    async currentPrincipal() {
      await this.loadBanners();
      await this.loadZones();
    }
  }
};
